import { FIELD_TYPES } from "constants/template-field-type";
import GridParagraphWithImageFieldsConfig from "segments/desktop/core-components/grid-paragraph-with-image/fields-config";
import { BACKGROUND_COLOR_OPTIONS } from "segments/segments-service";
import ThemeConfig from "segments/core-configs/theme-config";
import { COLUMN_WIDTH, MARGIN_BETWEEN_CARDS } from "./flexible-cards-consts";
import { ALIGN_TYPES } from "constants/align-types";
import AssetFieldsConfig from "components/core/asset/fields-config";

const { image } = AssetFieldsConfig;
const mobileImage = { ...image, label: "mobile image" };

export default {
  type: FIELD_TYPES.NESTED,
  label: "Cards",
  fields: {
    ...ThemeConfig,
    shadowCards: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Add shadow to all cards"
    },
    removeShadowOnHover: {
      type: FIELD_TYPES.BOOLEAN,
      label: "Remove shadow on hover"
    },
    gridAlignment:{
      type: FIELD_TYPES.COMBO,
            label: "Grid alignment",
            options: [
              ALIGN_TYPES.LEFT, ALIGN_TYPES.CENTER, ALIGN_TYPES.RIGHT
            ]
    },
    gridItems: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Grid Items",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          cardColor: {
            type: FIELD_TYPES.COLOR_PICKER,
            label: "Card color",
            possibleColors: BACKGROUND_COLOR_OPTIONS
          },
          cardNumOfColumnsWidth: {
            type: FIELD_TYPES.COMBO,
            label: "Card width",
            options: [
              { text: "25% (recommended image width: " + COLUMN_WIDTH + "px)", value: 1 },
              { text: "33% (recommended image width: " + (COLUMN_WIDTH * 1.33 + MARGIN_BETWEEN_CARDS) + "px)", value: 1.33 },
              { text: "33% - small version (recommended image width: " + (COLUMN_WIDTH * 1.2 + MARGIN_BETWEEN_CARDS) + "px)", value: 1.2 },
              { text: "50% (recommended image width: " + (COLUMN_WIDTH * 2 + MARGIN_BETWEEN_CARDS) + "px)", value: 2 },
              { text: "66% (recommended image width: " + (COLUMN_WIDTH * 2.66 + MARGIN_BETWEEN_CARDS) + "px)", value: 2.66 },
              {
                text: "75% (recommended image width: " + (COLUMN_WIDTH * 3 + MARGIN_BETWEEN_CARDS * 2) + "px)",
                value: 3
              },
              { text: "100% (recommended image width: " + (COLUMN_WIDTH * 4 + MARGIN_BETWEEN_CARDS * 3) + "px)", value: 4 }
            ]
          },
          ...GridParagraphWithImageFieldsConfig,
          mobileImage
        }
      }
    }
  }
};
